export const UPDATE_OTA_COUNTER = 'UPDATE_OTA_COUNTER';

export interface UpdateOTACounterAction {
	type: typeof UPDATE_OTA_COUNTER;
	payload: { counter: number; receivedOn: Date };
}

export function updateOTACounter(ota: { counter: number; receivedOn: Date }): UpdateOTACounterAction {
	return {
		type: UPDATE_OTA_COUNTER,
		payload: ota,
	};
}
